<div>
  <h2 class="text-[25px] font-semibold leading-tight mb-[22px]">Dashboard</h2>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-[15px]">

    <!-- Total Users -->
    <div class="p-[18px] rounded-xl bg-white dark:bg-surface-900 shadow">
      <h3 class="text-sm text-surface-500">Total Users</h3>
      <p class="text-2xl font-bold mt-2">120</p>
    </div>

    <!-- Active Users -->
    <div class="p-[18px] rounded-xl bg-white dark:bg-surface-900 shadow">
      <h3 class="text-sm text-surface-500">Active Users</h3>
      <p class="text-2xl font-bold mt-2">95</p>
    </div>

    <!-- Inactive Users -->
    <div class="p-[18px] rounded-xl bg-white dark:bg-surface-900 shadow">
      <h3 class="text-sm text-surface-500">Inactive Users</h3>
      <p class="text-2xl font-bold mt-2">25</p>
    </div>

  </div>
</div>
